import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Store, Select } from '@ngxs/store';
import {
  BaseComponent,LocationState,VenueManagementState
} from '@moduurnv2/libs-orderingapp/src';
import { ModalService } from '@moduurnv2/web/features/ui/components/modal/modal.service';
import { ResetCustomerPerTable, FetchInProgressStatus, Location, ResetInProgressStatus, CartState} from '@moduurnv2/libs-orderingapp/src/core';
import { Router } from '@angular/router';
import { ThemeOptions } from '@moduurnv2/features/ui/directives';
import { Observable, timer } from 'rxjs';

@Component({
  selector: 'orders-in-progress',
  templateUrl: './wj-orders-in-progress.component.html',
  styleUrls: ['./wj-orders-in-progress.component.scss'],
})

export class WJOrdersInProgressComponent extends BaseComponent implements OnInit {
  @Select(VenueManagementState.getInProgressStatus) inProgressStatus$: Observable<any>;
  @ViewChild('customerCount') guestCount: ElementRef;
  _modalClose: any = null;
  _data: any = null;
  selectedLocation: Location;
  guestsInActiveOrders: number;
  readyForMore:boolean = false;
  guestDetails: any;
  checkingStatus: boolean;
  lastCheck: string;

  set modalClose(modalRef: any) {
    this._modalClose = (data) => {
      this.modal.closeComponentModal(modalRef, data);
    };
  }

  themeOptions: ThemeOptions = {
  };

  constructor(private store: Store, private modal: ModalService,public router: Router) {
    super();
  }

  ngOnInit() {
    const cartItems = this.store.selectSnapshot(CartState.getCartItems);
    //if there's items in the cart then don't reset the customers per table.  Only do that if they completed the order.
    if (!(cartItems?.length > 0)) this.store.dispatch(new ResetCustomerPerTable({}))
    this.guestDetails = JSON.parse(localStorage.getItem('guest'));

    this.inProgressStatus$.subscribe((status:any) => {
      this.checkingStatus = false
      this.lastCheck = new Date().toLocaleTimeString();
      if (status?.guestsInActiveOrders >=0) {
        this.guestsInActiveOrders = status.guestsInActiveOrders;
        this.readyForMore = this._data.guestsInActiveOrders > status.guestsInActiveOrders;
      }
    });

    this.selectedLocation = this.store.selectSnapshot(
      LocationState.getSelectedLocation
    );
  }

  checkStatusNow() {
    const selectedTable = this.store.selectSnapshot(
      (app) => app && app.delivery && app.venuemanagement.selectedLoungeTable
    );

    if (this.selectedLocation?._id) {
      this.checkingStatus = true
      if (selectedTable?.name != 'pickup') {
        this.store.dispatch(new FetchInProgressStatus({locationId: this.selectedLocation._id, venue:selectedTable.name}));
      } else {
        if (this.guestDetails?.phone?.length > 3) { //arbitrary phone number length, just something, so we don't query nothing.
          this.store.dispatch(new FetchInProgressStatus({locationId: this.selectedLocation._id, phone:this.guestDetails.phone}));
        } else {
          this.store.dispatch(new ResetInProgressStatus()); //this really shouldn't happen but if it does clear out and return to the start.
        }
      }
    } else {
      this.store.dispatch(new ResetInProgressStatus()); //this really shouldn't happen but if it does clear out and return to the start.
    }
  }

  toTheMenu() {
    this.router.navigate([`/locations/${this.selectedLocation._id}/menu`]);
    this.modal.closeAllModals();
  }

  backToHome() {
    this.modal.closeAllModals();
  }

  set data(data: any) {
    this._data = data;
  }
}
